import { getLocale } from "../runtime";

const sv_curatedby = /** @type {(inputs: {name: NonNullable<unknown>}) => string} */ (inputs) => {
	return `Utvalt av ${inputs.name}`
};

const curatedby = /** @type {(inputs: {name: NonNullable<unknown>}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_curatedby(inputs)
	return "curatedBy";
};

export { curatedby as "curatedBy" };